import RdfResource from '@tpluscode/rdfine';
import * as rdfine from '@tpluscode/rdfine';
import * as Hydra from '@rdfine/hydra';
import { Alcaeus } from "./alcaeus.mjs";
import * as inferences from "./inferences/index.mjs";
import * as CoreMixins from "./Resources/CoreMixins/index.mjs";
import * as Extensions from "./Resources/Mixins/index.mjs";
import ResourceStoreImpl from "./ResourceStore.mjs";
import { defaultSelectors } from "./RootSelectors/index.mjs";
import "./Resources/Mixins/index.mjs";
import "./Resources/CoreMixins/index.mjs";
export * from '@rdfine/hydra';
export function create({
  dataset,
  fetch,
  Headers,
  parsers,
  rootSelectors,
  datasetFactory
}) {
  const getClient = () => alcaeus;

  const coreMixins = [CoreMixins.createResourceLoaderMixin(getClient), CoreMixins.createHydraResourceMixin(getClient), CoreMixins.OperationFinderMixin];
  const AlcaeusGenerated = coreMixins.reduce((base, mixin) => mixin(base), RdfResource);
  const factory = new rdfine.ResourceFactory(AlcaeusGenerated);
  AlcaeusGenerated.factory = factory;
  const alcaeus = new Alcaeus({
    datasetFactory,
    rootSelectors: Object.entries(rootSelectors || defaultSelectors),
    parsers: parsers,
    resources: new ResourceStoreImpl({
      dataset: dataset || datasetFactory(),
      inferences: Object.values(inferences),
      factory,
      datasetFactory
    }),
    fetch,
    Headers
  });
  factory.addMixin(...Object.values(Hydra));
  factory.addMixin(...Object.values(Extensions));
  return alcaeus;
}